import { Component } from '@angular/core';

@Component({
    selector: 'paypal-success',
  templateUrl: './paypal-success.component.html'
})
export class PayPalSuccessComponent {
}

